import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';


const BlueBoxWithText = ({
  value,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: theme.radius.md,
        backgroundColor: theme.palette.facet.accentBlue20,
        padding: '16px 24px',
      }}
    >
      <Text
        color={'primaryGray'}
        variant={'h5'}
        value={value}
        lineHeight={'md'}
        align={'left'}
      />
    </Box>
  );
};

BlueBoxWithText.defaultProps = {
  value: '',
};

BlueBoxWithText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default BlueBoxWithText;
